import { object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  fieldOnlyNumbersUpTo5000,
  requiredField,
  zeroToOneNumbers,
} from '~/ui/constants/errorMessages';

const validationSchema = object().shape({
  systemPrompt: string().required(requiredField).typeError(requiredField),
  temperature: string()
    .required(requiredField)
    .matches(/^(0(\.\d+)?|1(\.0+)?)$/, {
      // ^(?:0(?:\.[0-9]{1,2})?|1(?:\.00?)?)$ - 2 decimals
      message: zeroToOneNumbers,
      excludeEmptyString: true,
    }),
  maxTokens: string()
    .required(requiredField)
    .matches(/^(?:[1-9]\d{0,2}|[1-4],?\d{3}|5,?000)$/, {
      message: fieldOnlyNumbersUpTo5000,
      excludeEmptyString: true,
    }),
});

export default yupResolver(validationSchema);
